module.exports = __webpack_public_path__ + "img/research-icon.c9113d0a.png";